import { styled } from '@mui/system';

export const PrimaryLinkContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	marginBottom: theme.spacing(0.5)
}));

export const LinkContainer = styled('div')(({ theme }) => ({
	marginTop: theme.spacing(-0.5),
	marginLeft: theme.spacing(1.5),
	display: 'flex',
	marginBottom: theme.spacing(0.5),
	alignItems: 'center'
}));
